module.exports = __webpack_public_path__ + "211f354298c55b99c1843e1252c140e2.png";